import React, { useEffect, useState } from 'react';
import { Layout } from '../../components/Layout';
import { ContentProps } from '../../types/common';
import { BankInstrumentId } from './types';
import { Tabs } from './components/Tabs';
import { ActualForm } from './components/ActualForm';

export const Content: React.FC<ContentProps<BankInstrumentId>> = ({ available }) => {
  const [activeTab, setActiveTab] = useState(available[0].id);

  useEffect(() => {
    !activeTab && setActiveTab(available[0].id);
  }, [available, activeTab]);

  const active = available.find(({ id }) => id === activeTab);

  if (!active) {
    return null;
  }

  return (
    <Layout.Form>
      {available.length > 2 && (
        <Tabs available={available} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
      <ActualForm id={activeTab} parameters={active.parameters} />
    </Layout.Form>
  );
};
